import type {UseMutationResult} from '@tanstack/react-query';
import {useMutation, useQueryClient} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import {apiUrl} from '@/utils/api';

type MutateSearchCriteriaParams = {
    capacityDefaultId : string;
};

export const useDeleteCapacityDefault = () : UseMutationResult<
    void,
    unknown,
    MutateSearchCriteriaParams
> => {
    const fetch = useApiFetch();
    const queryClient = useQueryClient();

    return useMutation(async (mutateSearchCriteriaParams : MutateSearchCriteriaParams) : Promise<void> => {
        const {capacityDefaultId} = mutateSearchCriteriaParams;

        try {
            await fetch(apiUrl('/v1/capacity/capacity/delete-default').toString(), {
                method: 'DELETE',
                body: JSON.stringify({
                    capacityDefaultId,
                }),
            });
        } catch (e : unknown) {
            throw new Error('Unable to delete capacity default.');
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(['capacityDefaults']);
            await queryClient.invalidateQueries(['capacityCombined']);
        },
    });
};
